export const BANNER_VARIANTS = {
  CONTAINED: "contained",
  HEADER: "header"
};

export const EXTEND_BUTTON_TOOLTIP = "Preview expiration will be \n extended to one week from now.";

export const PREVIEW_EXTEND_KEY = "preview_extend_timestamp";
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const ONE_HOUR_MS = 60 * 60 * 1000;

export const LESS_THAN_ONE_HOUR = "Less than 1 hour";

export const EXTENDED_SUCCESS_MESSAGE = "Preview time has been extended successfully.";

export const ERROR_EXTENDING_PREVIEW_MESSAGE = "Error occurred while extending preview time. Please try again later.";
